export default __webpack_public_path__ + "static/media/Off2.026fc7dd.svg";